import React from 'react'
import styled from 'styled-components'

export default function Separator(props) {
  return (
    <Box>
      <hr />
      {props.text || '基本'}
      <hr />
    </Box>
  )
}

const Box = styled.div`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  hr:first-child {
    width: 5%;
  }

  hr:nth-child(2) {
    width: 80%;
  }
`
